'use strict';

var angular = require('angular');
var NewRoleDirective = function NewRoleDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/new-role.html'),
    controller: 'NewRoleController',
    scope: {
      visible: '=',
      isEdit: '=?',
      editRole: '=?'
    },
    link: function link($scope, element) {
      $scope.showAssignRolesModal = function () {
        angular.element('#assign-role-modal').modal('show');
      };
      $scope.showDeleteRoleModal = function () {
        angular.element('#delete-role-modal').modal('show');
      };
      $scope.$watch('isEdit', function () {
        element.find('.gdpr-popover').popover();
      });
    }
  };
};
NewRoleDirective.$inject = [];
module.exports = NewRoleDirective;